import React from "react";
import styles from "./HeaderBox.module.scss";
import { LeftOutlined } from "@ant-design/icons";

const HeaderBox = ({ text, onBackClick, children }) => {
  return (
    <div className={styles.headerBox}>
      <div className={styles.headerBoxReuseable}>
        {onBackClick && (
          <LeftOutlined className={`fontSize22 ${styles.backIcon}`} onClick={onBackClick} />
         )} 
        <div className={styles.headerText}>{text}</div>
      </div>
      <div className="header-box-buttons">{children}</div>
    </div>
  );
};

export default HeaderBox;
